/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Onsite_ProtocolInputs */

const en_svr_onsite_protocol = /** @type {(inputs: Svr_Onsite_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onsite Protocol`)
};

const ja_svr_onsite_protocol = /** @type {(inputs: Svr_Onsite_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現場プロトコル`)
};

const fr_svr_onsite_protocol = /** @type {(inputs: Svr_Onsite_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocole sur site`)
};

const de_svr_onsite_protocol = /** @type {(inputs: Svr_Onsite_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor-Ort-Protokoll`)
};

/**
* | output |
* | --- |
* | "Onsite Protocol" |
*
* @param {Svr_Onsite_ProtocolInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_onsite_protocol = /** @type {((inputs?: Svr_Onsite_ProtocolInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Onsite_ProtocolInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_onsite_protocol(inputs)
	if (locale === "ja") return ja_svr_onsite_protocol(inputs)
	if (locale === "fr") return fr_svr_onsite_protocol(inputs)
	return de_svr_onsite_protocol(inputs)
});